import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InsertChartIcon from '@material-ui/icons/InsertChart';

const styles = theme => ({
  proformaOn: {
    backgroundColor: 'rgba(0, 150, 136, 0.08)' //NOTE: must match theme colors
  }
});

const ProformaButton = ({ classes, isOpen, onToggle }) => {
  return (
    <Tooltip
      title={isOpen ? 'Hide Proforma' : 'View Proforma'}
      placement="left"
    >
      <IconButton
        className={classNames({ [classes.proformaOn]: isOpen })}
        color={isOpen ? 'secondary' : 'default'}
        onClick={() => onToggle()}
      >
        <InsertChartIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default withStyles(styles)(ProformaButton);